import React from 'react';
import type { ReactNode } from 'react';

import { SpaceDetailProvider } from './SpaceDetailProvider.tsx';
import { useEditorSpaceDetailFragment } from './useEditorSpaceDetailFragment.ts';

/**
 * Provides the editor document's space from EditorContentUnifiedQuery to useSpaceDetail and
 * useSpaceHomepageId readers of that space. While the next live doc loads, they wait instead of
 * reading the previous document's space.
 */
export const EditorSpaceDetailProvider = ({
	contentId,
	spaceKey,
	children,
}: {
	contentId: string;
	spaceKey: string | undefined;
	children: ReactNode;
}): React.JSX.Element => {
	const { isProvided, loading, data } = useEditorSpaceDetailFragment({ contentId });

	if (!isProvided) {
		return <>{children}</>;
	}

	return (
		<SpaceDetailProvider
			spaceKey={spaceKey ?? ''}
			loading={loading}
			spaceFragmentRef={loading ? null : (data?.space ?? null)}
		>
			{children}
		</SpaceDetailProvider>
	);
};
